import React from 'react';

const Events = () => <section className="Events">Events Component</section>;

export default Events;
